module.exports = __webpack_public_path__ + "static/media/waiting.be37db81.svg";